/**
 * Options:
 * xs: 0
 * sm: 640
 * md: 768
 * lg: 1024
 * xl: 1280
 * xl2: 1350
 * xxl: 1536
 */
export const screen = {
  xs: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  xl2: 1350,
  xxl: 1536
};

/**
 * Options:
 * xs: 0
 * sm: 640
 * md: 768
 * lg: 1024
 * xl: 1280
 * xl2: 1350
 * xxl: 1536
 */
export const device = {
  xs: `(min-width: ${screen.xs}px)`,
  sm: `(min-width: ${screen.sm}px)`,
  md: `(min-width: ${screen.md}px)`,
  lg: `(min-width: ${screen.lg}px)`,
  xl: `(min-width: ${screen.xl}px)`,
  xl2: `(min-width: ${screen.xl2}px)`,
  xxl: `(min-width: ${screen.xxl}px)`
};
